import { render, staticRenderFns } from "./ConfirmLogout.vue?vue&type=template&id=15679dac"
import script from "./ConfirmLogout.vue?vue&type=script&lang=js"
export * from "./ConfirmLogout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports